// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isGetCustomObjectsUserRelationshipTypeAttributesResult = objectOf({
  items: arrayOf(
    objectOf({
      id: number,
      display_name: string,
      display_label: string,
      json_type: string,
      // format drives jsonTypeToCoAttributeType (e.g. date-time → datetime); reject wrong types.
      format: maybe(string, true),
    })
  ),
});
